import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import GuestLayout from 'layout/GuestLayout';

// render - login
const Terms = Loadable(lazy(() => import('pages/guest/terms')));
const Privacy = Loadable(lazy(() => import('pages/guest/privacy')));

const LoginRoutes = {
    path: '/',
    element: <GuestLayout />,
    children: [
        {
            path: 'privacy',
            element: <Privacy />
        },
        {
            path: 'terms',
            element: <Terms />
        }
    ]
};

export default LoginRoutes;
